import { useEffect, useState } from 'react'
import { AppShell, type PageKey } from './components/AppShell'
import { useAuth } from './contexts/AuthContext'
import { useLanguage } from './contexts/LanguageContext'
import { ClientsPage } from './pages/ClientsPage'
import { DashboardPage } from './pages/DashboardPage'
import { LeadsPage } from './pages/LeadsPage'
import { LoginPage } from './pages/LoginPage'
import { OrdersPage } from './pages/OrdersPage'
import { ExpensesPage } from './pages/ExpensesPage'
import { PlaceholderPage } from './pages/PlaceholderPage'

function pageFromHash(): PageKey {
  const value = window.location.hash.replace('#/', '').split('?')[0] as PageKey
  const allowed: PageKey[] = ['dashboard', 'leads', 'clients', 'orders', 'projects', 'calendar', 'purchases', 'finances', 'tasks', 'reports', 'settings']
  return allowed.includes(value) ? value : 'dashboard'
}

function SetupScreen() {
  const { t } = useLanguage()
  return <div className="setup-screen"><div className="setup-card"><div className="brand-mark large">SG</div><span className="eyebrow">SG Flow</span><h1>{t('configurationNeeded')}</h1><p>{t('configurationText')}</p><pre>VITE_SUPABASE_URL=...{`\n`}VITE_SUPABASE_PUBLISHABLE_KEY=...</pre></div></div>
}

export default function App() {
  const { user, loading, configured } = useAuth()
  const [page, setPage] = useState<PageKey>(pageFromHash)

  useEffect(() => {
    const onHash = () => setPage(pageFromHash())
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  const changePage = (next: PageKey) => {
    window.location.hash = `/${next}`
    setPage(next)
  }

  if (!configured) return <SetupScreen />
  if (loading) return <div className="loading-screen"><div className="loader" /></div>
  if (!user) return <LoginPage />

  let content
  if (page === 'dashboard') content = <DashboardPage onOpenLead={() => changePage('leads')} />
  else if (page === 'clients') content = <ClientsPage />
  else if (page === 'leads') content = <LeadsPage />
  else if (page === 'orders') content = <OrdersPage />
  else if (page === 'finances') content = <ExpensesPage />
  else content = <PlaceholderPage page={page} />

  return <AppShell page={page} onPageChange={changePage}>{content}</AppShell>
}
